const DESTINATION = 'global-admin:after-sign-in';

function isSignInItself(target: string) {
  return target.startsWith('/login') || target.startsWith('/auth/callback');
}

export function rememberWhereTheyWereGoing(pathname: string, search: string) {
  const target = `${pathname}${search}`;
  if (isSignInItself(target)) return;
  try {
    sessionStorage.setItem(DESTINATION, target);
  } catch (unavailable) {
    console.warn('could not remember where to go after signing in', unavailable);
  }
}

export function takeWhereTheyWereGoing(fallback: string) {
  try {
    const target = sessionStorage.getItem(DESTINATION);
    sessionStorage.removeItem(DESTINATION);
    return target && !isSignInItself(target) ? target : fallback;
  } catch (unavailable) {
    console.warn('could not read where to go after signing in', unavailable);
    return fallback;
  }
}
